<template>
  <div class="GlobalFormDemo">
    <GlobalForm class="search-form" :init-data="initData" :form-rules="formRules" :form-item-list="formItemList" :needBtnLoading="true"
      :inline="true" round :labelWidth="90" @handleConfirm="handleConfirm" confirmBtnName="查询">
      <el-form-item class="el_from" label="订单号" slot="orderPlole" style="margin: 0" label-width="60px">
        <el-input v-model="sellOrderNo" :clearable="true" size="mini" placeholder="请输入订单号"></el-input>
      </el-form-item>
      <el-form-item class="el_from" label="预约提货门店" slot="storeId" style="margin: 0" label-width="100px">
        <el-select v-model="storeId" placeholder="请选择或输入门店查询" filterable clearable>
          <el-option v-for="item in storeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from" label="串号" slot="orderime" style="margin: 0" label-width="40px">
        <el-input v-model="imei" :clearable="true" size="mini" placeholder="请输入串号"></el-input>
      </el-form-item>
      <el-form-item class="el_from" label="商品编码" slot="productCode" style="margin: 0" label-width="75px">
        <el-input v-model="productCode" :clearable="true" size="mini" placeholder="请输入商品编码"></el-input>
      </el-form-item>
      <el-form-item class="el_from" label="顾客手机号" slot="userPhone" style="margin: 0" label-width="90px">
        <el-input v-model="userPhone" :clearable="true" size="mini" placeholder="请输入顾客手机号"></el-input>
      </el-form-item>
      <el-form-item class="el_from" label="下单时间" slot="xiaSelect" style="margin: 0" label-width="75px">
        <el-date-picker v-model="entryTime" type="daterange" start-placeholder="开始日期" range-separator="~"
          end-placeholder="结束日期" :clearable="false" :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>
      <el-form-item class="el_from" label="商品类型" slot="catalog" style="margin: 0" label-width="75px">
        <el-select v-model="catalog" size="mini" placeholder="请选择" clearable>
          <el-option v-for="item in catalogData" :key="item.label" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from" label="提货方式" slot="deliveryType" style="margin: 0" label-width="75px">
        <el-select v-model="deliveryType" size="mini" placeholder="请选择" clearable>
          <el-option v-for="item in deliveryTypeData" :key="item.label" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </el-form-item>
    </GlobalForm>
    <div style="text-align: right;margin-bottom: 20px" slot="AddSlot">
      <!-- <el-button type="warning" size="mini" @click.native="importVisible = true; isLeadingOut = false">导入线下销售数据</el-button> -->
      <el-button icon="el-icon-download" size="small" :loading="exportLoading" type="success" @click="exportExcel">导出Excel</el-button>
    </div>
    <el-dialog title="导入销售记录" :visible.sync="importVisible" :close-on-click-modal="false" class="import-business-dialog"
      width="500px">
      <div class="cance-tip">
        <div>
          说明：请下载数据模板后按照表格提示填写后导入
        </div>
      </div>
      <div class="step">
        <div class="step-title">
          <span>Step1</span>
        </div>
        <div class="step-content">
          <span style="margin-right: 12px">表格下载</span>
          <el-link type="primary" @click="download">点击下载模板表格</el-link>
        </div>
        <div class="step-title">
          <span>Step2</span>
        </div>
        <div class="tip">
          <span class="tip-title">上传表格</span>
          <span class="tip-content">请上传.xls或.xlsx格式的excel文件，大小10M内</span>
        </div>
        <div class="step2-content">
          <el-upload ref="upload" :limit="1" :headers="headers" :auto-upload="false" :http-request="uploadFile"
            :before-upload="onUpload" accept=".xls,.xlsx" action="customize">
            <el-button slot="trigger" size="small" type="primary">选取文件
            </el-button>
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="importVisible = false">取消</el-button>
        <el-button type="primary" @click.native="importSuccess">确定</el-button>
      </span>
    </el-dialog>

    <GlobalDialog title="操作提示" :show="codeShow" @submitPopupData="codeSubmit" :width="500" top="6%"
      @onClose="codeShow = false; code = ''" @resetPopupData=" codeShow = false; code = '' ">
      <p style="font-size: 16px;text-align: center;color: #000;margin-bottom: 20px;">{{
        isLeadingOut ? '是否确认导出订单？' : '是否确定导入代卖销售数据？' }}</p>
      <el-form>
        <el-form-item label="动态口令" label-width="80px">
          <el-input placeholder="请输入谷歌动态口令" v-model=" code " clearable />
        </el-form-item>
      </el-form>
    </GlobalDialog>
    <GlobalDialog title="操作提示" :show=" cdShow " @submitPopupData=" cdSubmit " :width=" 500 " top="6%"
      @onClose=" codeShow = false; command = '' " @resetPopupData=" cdShow = false; command = '' ">
      <p style="font-size: 16px;text-align: center;color: #000;margin-bottom: 20px;">
        是否确定导入代卖销售数据?</p>
      <el-form>
        <el-form-item label="动态口令" label-width="80px">
          <el-input placeholder="请输入谷歌动态口令" v-model=" command " clearable />
        </el-form-item>
      </el-form>
    </GlobalDialog>
    <!-- 确认导表订单 -->
    <el-dialog title="确认导入订单" :visible.sync=" sureExDialog " :close-on-click-modal=" false " width="800px">
      <div class="exStitle">说明：请确认导入订单，导入后系统自动根据销售价计算代卖商户结算金额</div>
      <GlobalTable ref="GlobalTable" :columns=" urtableColumns " :data=" urDataList " :maxHeight=" 700 " :isPagination=" false ">
        <el-table-column label="订单状态" slot="storeName" align="center">
          <template>
            <span>已取消</span>
          </template>
        </el-table-column>
        <el-table-column label="销售价" slot="smStaffName" align="center">
          <template slot-scope="{ row }">
            <span style="color: red;" v-if=" row.sellPrice ">{{ row.sellPrice }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="销售渠道" slot="waitAmount" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.sellTypeAct === "1" ? 'C端' : 'B端' }}</span>
          </template>
        </el-table-column>
      </GlobalTable>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click=" sureExDialog = false ">关 闭</el-button>
        <el-button size="small" type="primary" @click.native=" exportSure ">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from "moment";
import { MessageBox } from "element-ui";
import { encryptByDES } from "@/utils/3DES";
import { http} from "@/utils/request/newIndex";
import GlobalDialog from "@/components/global/components/GlobalDialog.vue";

let checkPhone = (rule, value, callback) => {
  let reg = /^1[345789]\d{9}$/;
  if (!reg.test(value)) {
    callback(new Error("请输入正确的手机号码"));
  } else {
    callback();
  }
};
let checkPrice = (rule, value, callback) => {
  if (value < 50) {
    callback(new Error("扣款条件不能小于50元"));
  } else {
    callback();
  }
};
export default {
  name: "Form",
  components: { GlobalDialog },
  props: {},
  data() {
    return {
      deliveryType: "",
      command: "",
      cdShow: false,
      sureExDialog: false,
      urtableColumns: [
        { label: "代卖码", prop: "phoneUid" },
        { label: "代卖商户", prop: "businessName" },
        { slotName: "storeName" },
        { slotName: "smStaffName" },
        { slotName: "waitAmount" },
      ],
      urDataList: [],
      catalogData: [
        {
          label: "优品机",
          value: '00'
        },
        {
          label: "演示机",
          value: '01'
        },
        {
          label: "资源机",
          value: '02'
        }
      ],
      deliveryTypeData: [
        {
          label: "到店自提",
          value: '01'
        },
        {
          label: "送货上门",
          value: '02'
        }
      ],
      // 是否导出还是导入
      isLeadingOut: false,
      codeShow: false,
      headers: {
        ACCESS_TOKEN: localStorage.getItem("token"),
        channel: "platformPc",
        TOKEN: "",
      },
      // 弹框
      importVisible: false,
      code: "",
      imei: "",
      productCode: "",
      userPhone: "",
      storeList: [],
      merchantSelectList: [],
      filtterSelectList: [],
      initData: null,
      dialogVisible: false,
      sellOrderNo: "",
      companyId: "",
      storeId: "",
      entryTime: [
        moment().day(moment().day()-30).format("YYYY-MM-DD 00:00:00"),
        moment().format("YYYY-MM-DD 23:59:59"),
      ],
      shtryTime: null,
      catalog: '',
      companySelectList: [],
      companyMatchSelectList: [],
      allMerchantSelectList: [],
      formItemList: [{ slotName: "orderPlole" }, { slotName: "orderime" }, { slotName: "productCode" }, { slotName: "userPhone" }, { slotName: 'deliveryType' }, { slotName: "catalog" }, { slotName: "storeId" }, { slotName: "xiaSelect" }],
      modelform: {
        matchChannelId: "",
        merchantId: "",
        companyId: "",
        takeEffectTime: "",
        command: "",
      },
      SeachParams: {},
      formRules: {},
      butLoading: false,
      middleRegionVos: [],
      dialogMiddleRegionTitle: "",
      dialogMiddleRegionVisible: false,
      dialogDelVisible: false,
      commandDisableShow: false,
      applyEndTime: "",
      applyStartTime: '',
      createEndTime: "",
      createStartTime: "",
      exportLoading: false
    };
  },
  created() {
    this.handleConfirm();
    this.getAllStoreSelectList()
  },
  watch: {
    "modelform.matchChannelId"(val) {
      this.modelform.companyId = "";
      this.modelform.merchantId = "";

    },
    "modelform.companyId"(val) {
      this.modelform.merchantId = "";
    },
  },
  methods: {
    // 获取全部门店
    getAllStoreSelectList() {
      this.storeList = []
      _api.getAllStoreSelectList().then(res => {
        if (res.code == 1) {
          this.storeList = res.data
          this.storeList.unshift({
            isEnable: true,
            key: "-1",
            value: "公司总部",
          })
        }
      })
    },
    //确认导出
    cdSubmit() {
     
    },
    exportSure() {
      this.cdShow = true
    },
    onUpload(e) {
      let TOKEN = encryptByDES(
        encryptByDES(
          new Date().getTime().toString(),
          "63e42c2444e94c1ebca21d30d2aa39a5"
        ),
        localStorage.getItem("token") || ""
      );
      this.headers.TOKEN = TOKEN;
    },
    //下载模板
    download() {
      const link = document.createElement("a");
      link.href = "/static/导入线下销售数据模板.xlsx";
      link.setAttribute("download", "线下销售数据模板.xlsx");
      document.body.appendChild(link);
      link.click();
    },
    importSuccess() {
      this.$refs.upload.submit();
      // this.importVisible = false;
    },
   // 导出
    exportExcel() {
      this.exportLoading = true
      http.sellExcelout({ ...this.SeachParams}).then((res) => {
          const content = res;
          const blob = new Blob([content]);

          let reader = new FileReader(); // 创建读取文件对象
          reader.addEventListener("loadend", () => {
            try {
              let data = JSON.parse(reader.result);
              if (data.code === 0) {
                MessageBox.alert(data.msg, "错误提示", {
                  type: "error",
                });
              }
            } catch (err) {
              const fileName = "销售订单明细.xlsx";
              if ("download" in document.createElement("a")) {
                // 非IE下载
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
              } else {
                // IE10+下载
                navigator.msSaveBlob(blob, fileName);
              }
            }
          });
          reader.readAsText(blob, "utf-8");
        }).finally(() => {
            this.exportLoading = false
          });
    },
    handleConfirm(data,cd) {
      if (this.entryTime === null) {
        (this.startTime = ""), (this.endTime = "");
      } else {
        (this.startTime = moment(this.entryTime[0]).format("x")),
          (this.endTime = moment(this.entryTime[1]).format("x"));
      }
      const SeachParams = {
        storeId: this.storeId,
        sellOrderNo: this.sellOrderNo,
        userPhone: this.userPhone,
        catalog: this.catalog,
        endTime: this.endTime,
        startTime: this.startTime,
        imei: this.imei,
        deliveryType: this.deliveryType,
        productCode: this.productCode,
        pageNum: 1,
        pageSize: 10,
      };
      this.SeachParams = JSON.parse(JSON.stringify(SeachParams));
      SeachParams.disuseLoding = () => {
        if (typeof cd === 'function') {
          cd()
        }
      },
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.exStitle {
  margin-bottom: 15px;
  color: #ff8080;
  font-size: 14px;
}

.import-business-dialog {
  .step {
    .step-title {
      color: #0981ff;
      margin-bottom: 10px;
      padding-left: 6px;
      border-left: 3px solid;
      border-radius: 1.5px;
    }

    .step-content,
    .step2-content {
      margin-bottom: 26px;
    }

    .step2-content>div {
      display: flex;
    }

    .step2-content {
      .upload-demo {
        display: flex;
        justify-content: start;

        .el-upload-list {
          width: 200px;
        }
      }
    }

    .tip {
      margin-bottom: 12px;

      .tip-title {
        color: #666666;
        margin-right: 12px;
      }

      .tip-content {
        color: #ff687b;
        font-size: 12px;
      }
    }
  }
}

.cance-tip {
  color: #ff8080;
  font-size: 14px;
  margin-bottom: 20px;
}

.GlobalFormDemo {
  /deep/ .el-form--inline .el-form-item {
    margin-right: 10px !important;
  }

  .search-form {
    /deep/ .el-select>.el-input {
      width: 185px !important;
    }
  }

  .add-form {
    /deep/ .el-input-group__append {
      border: 1px solid #0981ff;
      background: #0981ff;
      color: #ffffff;
    }

    /deep/ .el-input-group__prepend {
      border: 1px solid #0981ff;
      background: #0981ff;
      color: #ffffff;
    }

    /deep/ .el-select {
      width: 100%;
    }
  }

  .rules-form {
    .rule-title {
      display: flex;
      align-items: center;
      color: #ff8080;
      margin-bottom: 20px;
    }

    .tip_ico {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }

    /deep/ .el-input-group__append {
      border: 1px solid #0981ff;
      background: #0981ff;
      color: #ffffff;
    }
  }

  .del-title {
    color: #ff8080;
    font-size: 12px;

    .sure_tip {
      margin-top: 15px;
      font-size: 16px;
      color: #333333;
    }
  }

  .command {
    display: flex;
    align-items: center;

    /deep/ .el-input {
      width: 300px;
    }
  }
}
</style>
